<a (click)="showHint = true" class="infotext-button"><i class="icon-help-circle"></i>@if (textkeyButton) {
<span> {{textkeyButton | translate}}</span>
}</a>
@if (showHint) {
  <div class="infotext-background" (click)="closeHint($event)">
    @if (showHint) {
      <div class="infotext-content" [style.top]="scrollOffset + 'px'"><i class="close icon-x" (click)="closeHint($event)"></i><div [innerHTML]="textkeyContent | translate"></div></div>
    }
  </div>
}
